import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { coursesData } from "../../pages/courses/coursesData";

const Hero = () => {
    const [index, setIndex] = useState(0);


    const visibleCourses = coursesData;

    useEffect(() => {
        const timer = setInterval(() => {
            setIndex((prev) => (prev + 1) % visibleCourses.length);
        }, 5000);

        return () => clearInterval(timer);
    }, [visibleCourses.length]);

    // Safe index access to prevent crashes on hot-reload or data changes
    const safeIndex = index % visibleCourses.length;
    const current = visibleCourses[safeIndex] || visibleCourses[0];

    return (
        <section className="hero-container" id="home">
            <div className="hero-bg-grid"></div>

            <div className="hero-content">
                {/* LEFT CONTENT */}
                <div className="hero-text">
                    <span className="badge">🚀 Skill Ascent Courses</span>

                    <div key={index} className="animate-text">
                        <h1>{current.title}</h1>

                        <p>{current.description}</p>

                        {/* META INFO */}
                        <div className="hero-meta">
                            <span className="meta-pill">
                                <i className="fa-solid fa-layer-group"></i> {current.category}
                            </span>
                            <span className="meta-pill">
                                <i className="fa-solid fa-clock"></i> {current.duration}
                            </span>
                        </div>
                    </div>

                    <div className="cta-group">
                        <Link
                            to="/courses"
                            className="btn-primary"
                            onClick={() => window.scrollTo(0, 0)}
                            style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '8px' }}
                        >
                            Explore Courses <i className="fa-solid fa-arrow-right"></i>
                        </Link>

                        {/* {["Graphic Designing", "Digital Marketing", "Video Editing"].includes(current.title) ? (
                            <button
                                className="btn-secondary"
                                onClick={() => {
                                    navigate("/calendly-demo");
                                    window.scrollTo(0, 0);
                                }}
                            >
                                <span>Book a Demo</span> <i className="fa-solid fa-calendar-check" style={{ marginLeft: '4px' }}></i>
                            </button>
                        ) : (
                            <button
                                className="btn-secondary"
                                onClick={() => {
                                    const courseDetails = coursesData.find(c => c.title === current.title);
                                    if (courseDetails) {
                                        let ref = new URLSearchParams(window.location.search).get("ref");
                                        const path = courseDetails.seoPath ? `/${courseDetails.seoPath}` : `/course/${courseDetails.id}`;
                                        navigate(`${path}${ref ? '?ref=' + encodeURIComponent(ref) : ''}`);
                                    } else {
                                        const section = document.getElementById('courses1');
                                        if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                    }
                                    window.scrollTo(0, 0);
                                }}
                            >
                                <span>Notify Me</span> <i className="fa-solid fa-bell" style={{ marginLeft: '4px' }}></i>
                            </button>
                        )} */}
                    </div>
                </div>

                {/* RIGHT VISUAL */}
                <div className="hero-visual">
                    <div className="card-stack">
                        <div className="card-layer layer-0"></div>
                        <div className="card-layer layer-1"></div>
                        <div className="card-layer layer-2"></div>

                        <div className="card-layer layer-3" key={index}>
                            <span className="card-text">{current.role}</span>
                        </div>

                        <div className="card-glow"></div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
